module.exports = __webpack_public_path__ + "static/media/logos1.03b69004.png";